import { Component, OnInit } from '@angular/core';
import { LanguageItem } from '../../interfaces/laguage-item';
import { environment } from '../../../../environments/environment';
import { Commons } from '../../Commons';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { LanguageUtilService } from '../../../services/language-util.service';
import { TranslocoModule } from '@ngneat/transloco';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-select-language-modal',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule
  ],
  templateUrl: './select-language-modal.component.html',
  styleUrl: './select-language-modal.component.scss'
})
export class SelectLanguageModalComponent implements OnInit {
  dfLang = environment.dfConfigLang
  languages: LanguageItem[] = [
    {
      code: this.dfLang,
      icon: `${Commons.ICON_FLAG_PATH}${this.dfLang}${Commons.ICON_FLAG_FORMAT}`,
      label: `language.${this.dfLang}-name`
    }
  ]
  icon: string = Commons.ICON_WARNING

  constructor(
    public modalRef: MdbModalRef<SelectLanguageModalComponent>,
    private langServ: LanguageUtilService
  ) { }

  ngOnInit(): void {
    this.languages = new Array()
    for (let item of this.langServ.getValidLanguages()) {
      if (item != this.langServ.getLangActive()) {
        this.languages.push({
          code: item,
          icon: `${Commons.ICON_FLAG_PATH}${item}${Commons.ICON_FLAG_FORMAT}`,
          label: `language.${item}-name`
        })
      }
    }
  }

  setLang(arg: string): void {
    this.modalRef.close(arg)
  }

  cancel(): void {
    this.modalRef.close(this.langServ.getLangActive())
  }
}
